import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from 'react-icons/fa';

function HeroPage() {
  return (
    <div className="relative min-h-screen text-white">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

      {/* Main content */}
      <div className="hero-wrap text-center relative z-10 flex flex-col justify-between min-h-screen">
        <div className="flex-grow flex items-center justify-center px-4">
         
        </div>

        <br/>
        <div className="py-72">
          <div className="flex justify-center gap-6">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Facebook page"
              className="text-2xl md:text-3xl hover:text-[#1877F2] transition-colors duration-300"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Twitter page"
              className="text-2xl md:text-3xl hover:text-[#1DA1F2] transition-colors duration-300"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Instagram page"
              className="text-2xl md:text-3xl hover:text-[#E1306C] transition-colors duration-300"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our LinkedIn page"
              className="text-2xl md:text-3xl hover:text-[#0A66C2] transition-colors duration-300"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our YouTube channel"
              className="text-2xl md:text-3xl hover:text-[#FF0000] transition-colors duration-300"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroPage;
